// src/pages/pentest/web/nav.jsx  (or your current web nav path)
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate, useLocation } from 'react-router-dom';

// Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import StorageIcon from '@mui/icons-material/Storage';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BugReportIcon from '@mui/icons-material/BugReport';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();

  // extract pentest_id as the last segment
  const pathParts = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
  const pentest_id = pathParts[pathParts.length - 1];

  const [selectedTab, setSelectedTab] = useState(0);
  const [reportAnchorEl, setReportAnchorEl] = useState(null); // NEW

  useEffect(() => {
    const path = location.pathname;
    if (/^\/pentest\/web\/dashboard\/.+$/.test(path)) setSelectedTab(0);
    else if (/^\/pentest\/web\/scope\/.+$/.test(path)) setSelectedTab(1);
    else if (/^\/pentest\/web\/assets\/.+$/.test(path)) setSelectedTab(2);
    else if (/^\/pentest\/web\/threat_model\/.+$/.test(path)) setSelectedTab(3);
    else if (/^\/pentest\/web\/exploits\/.+$/.test(path)) setSelectedTab(4);
    else if (/^\/pentest\/web\/report\/(pentest|executive|attestation|recon)\/\d+$/.test(path)) setSelectedTab(5);
    else setSelectedTab(0);
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    // prevent navigating when clicking the Report dropdown tab
    if (newValue === 5) return;

    setSelectedTab(newValue);
    switch (newValue) {
      case 0:
        navigate(`/pentest/web/dashboard/${pentest_id}`);
        break;
      case 1:
        navigate(`/pentest/web/scope/${pentest_id}`);
        break;
      case 2:
        navigate(`/pentest/web/assets/${pentest_id}`);
        break;
      case 3:
        navigate(`/pentest/web/threat_model/${pentest_id}`);
        break;
      case 4:
        navigate(`/pentest/web/exploits/${pentest_id}`);
        break;
      default:
        break;
    }
  };

  // NEW: Report menu
  const handleReportClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setReportAnchorEl(e.currentTarget);
  };
  const handleReportClose = () => setReportAnchorEl(null);
  const handleReportItem = (type) => {
    setReportAnchorEl(null);
    setSelectedTab(5);
    navigate(`/pentest/web/report/${type}/${pentest_id}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        p: 2,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        mb: 3,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography variant="h4" fontWeight="bold">
          Pentest
        </Typography>
      </Box>

      <Tabs value={selectedTab} onChange={handleTabChange} textColor="primary" indicatorColor="primary">
        <Tab icon={<DashboardIcon />} label="Dashboard" />
        <Tab icon={<AssignmentIcon />} label="Scope" />
        <Tab icon={<StorageIcon />} label="Assets" />
        <Tab icon={<AccountTreeIcon />} label="Threat Model" />
        <Tab icon={<BugReportIcon />} label="Exploits" />
        {/* NEW: Report dropdown tab */}
        <Tab
          icon={<DescriptionIcon />}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              Report <ArrowDropDownIcon fontSize="small" />
            </Box>
          }
          onClick={handleReportClick}
        />
      </Tabs>

      {/* NEW: Reports Menu */}
      <Menu anchorEl={reportAnchorEl} open={Boolean(reportAnchorEl)} onClose={handleReportClose}>
        <MenuItem onClick={() => handleReportItem('pentest')}>
          <DescriptionIcon style={{ marginRight: 8 }} /> Pentest Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('executive')}>
          <AssessmentIcon style={{ marginRight: 8 }} /> Executive Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('recon')}>
          <AssessmentIcon style={{ marginRight: 8 }} /> Recon Report
        </MenuItem>
        <MenuItem onClick={() => handleReportItem('attestation')}>
          <EmojiEventsIcon style={{ marginRight: 8 }} /> Attestation
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default Nav;
